const sidebarMenuConfig = [
  {
    to: "/dashboard",
    label: "Dashboard",
    icon: () => (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.640615 5.43373L5.06936 1.00497C6.41277 -0.334989 8.58721 -0.334989 9.93061 1.00497L14.3594 5.43373C14.7709 5.84309 15.0016 6.40009 15 6.98061V13.4669C14.9986 14.3135 14.3122 14.9993 13.4656 15H1.53437C0.687724 14.9993 0.00138569 14.3135 9.53674e-06 13.4669V6.98061C-0.00163174 6.40009 0.229053 5.84309 0.640615 5.43373ZM1.87501 13.125H4.99998V11.1362C4.99998 9.81834 6.06835 8.74996 7.38624 8.74996H7.61373C8.93162 8.74996 9.99999 9.81834 9.99999 11.1362V13.125H13.125V6.98061C13.1248 6.89772 13.092 6.81827 13.0337 6.75935L8.60499 2.33059C7.99488 1.72031 7.00556 1.72019 6.39528 2.3303C6.39519 2.33039 6.39507 2.33051 6.39498 2.33059L1.96624 6.75935C1.90797 6.81827 1.87518 6.89772 1.87498 6.98061V13.125H1.87501Z"
          fill="white"
          className="group-hover:fill-orange-200"
        />
      </svg>
    ),
  },
  {
    to: "/projects",
    label: "Projects",
    icon: () => (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.31184 11.6891C3.59314 11.9704 3.75117 12.352 3.75117 12.7499C3.75117 13.1477 3.59314 13.5293 3.31184 13.8106C2.51269 14.3585 1.62066 14.7567 0.679192 14.9858C0.587812 15.0069 0.492571 15.0045 0.402379 14.9787C0.312188 14.953 0.229995 14.9048 0.163491 14.8387C0.0969868 14.7726 0.0483457 14.6907 0.0221188 14.6006C-0.00410803 14.5106 -0.00706329 14.4153 0.0135296 14.3238C0.241779 13.3818 0.6393 12.489 1.18672 11.6891C1.32608 11.5492 1.49168 11.4383 1.67402 11.3625C1.85636 11.2868 2.05185 11.2479 2.24928 11.2479C2.44671 11.2479 2.6422 11.2868 2.82454 11.3625C3.00688 11.4383 3.17248 11.5492 3.31184 11.6891ZM3.91 5.08761C3.92 5.07324 3.93063 5.05886 3.91 5.08761V5.08761ZM11.2498 5.31327C11.2498 4.89881 11.0852 4.50133 10.7921 4.20827C10.4991 3.9152 10.1016 3.75056 9.6872 3.75056C9.27278 3.75056 8.87533 3.9152 8.58228 4.20827C8.28924 4.50133 8.12461 4.89881 8.12461 5.31327C8.12461 5.72772 8.28924 6.1252 8.58228 6.41826C8.87533 6.71133 9.27278 6.87597 9.6872 6.87597C10.1016 6.87597 10.4991 6.71133 10.7921 6.41826C11.0852 6.1252 11.2498 5.72772 11.2498 5.31327ZM10.0147 11.0196L10.0197 11.0159C9.88988 11.4708 9.71765 11.9126 9.50531 12.3354C9.00543 13.4251 8.16002 14.3193 7.10018 14.8795C6.86917 14.9758 6.61791 15.0135 6.3688 14.9892C6.1197 14.9648 5.88049 14.8792 5.6725 14.7399C5.46452 14.6007 5.29421 14.4121 5.17677 14.1911C5.05934 13.9701 4.99841 13.7234 4.99944 13.4731V11.8766C4.99697 11.38 4.79862 10.9045 4.44751 10.5533C4.09639 10.2022 3.62088 10.0038 3.12433 10.0014H1.49424C1.24945 10.0024 1.00822 9.94285 0.792042 9.828C0.575869 9.71314 0.391482 9.54656 0.255328 9.34312C0.119173 9.13967 0.0354834 8.90569 0.0117241 8.66204C-0.0120351 8.41839 0.0248744 8.17265 0.119161 7.94673C0.66682 6.91016 1.54126 6.08334 2.6068 5.59455C3.02429 5.38496 3.46062 5.21522 3.91 5.08761C3.89062 5.11512 3.9 5.10136 3.91 5.08761C6.30451 1.7503 9.04279 0.106964 12.7861 7.49505e-05C13.0753 -0.00231452 13.3621 0.0524514 13.6301 0.161228C13.8981 0.270004 14.1419 0.430648 14.3476 0.633934C14.5533 0.83722 14.7168 1.07914 14.8288 1.34581C14.9408 1.61248 14.9989 1.89864 15 2.18786C14.8931 5.95773 13.3593 8.62182 10.0203 11.0159L10.0147 11.0196ZM13.1249 2.16161C13.1193 2.08296 13.0838 2.00945 13.0257 1.9562C12.9675 1.90295 12.8912 1.874 12.8124 1.87532C9.6647 1.96533 7.62458 3.12548 5.55447 6.00961C5.04926 6.73308 4.59942 7.49367 4.20877 8.2849C4.79119 8.46158 5.32204 8.77695 5.75577 9.20396C6.18949 9.63097 6.51313 10.1568 6.69891 10.7365L8.05086 10.0639C8.36713 9.87636 8.68714 9.66758 8.99154 9.44943C11.8748 7.37603 13.0349 5.33577 13.1249 2.16161ZM10.0197 11.0159L10.026 11.0115L10.0203 11.0159H10.0197Z"
          fill="white"
          className="group-hover:fill-orange-200"
        />
      </svg>
    ),
  },

  // {
  //   to: "/domains",
  //   label: "Domains",
  //   icon: () => (
  //     <svg
  //       width="15"
  //       height="15"
  //       viewBox="0 0 15 15"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <g clipPath="url(#clip0_97_268)">
  //         <path
  //           d="M7.5 0C6.01664 0 4.5666 0.439867 3.33323 1.26398C2.09986 2.08809 1.13856 3.25943 0.570907 4.62987C0.00324965 6.00032 -0.145275 7.50832 0.144114 8.96318C0.433503 10.418 1.14781 11.7544 2.1967 12.8033C3.2456 13.8522 4.58197 14.5665 6.03683 14.8559C7.49168 15.1453 8.99968 14.9968 10.3701 14.4291C11.7406 13.8614 12.9119 12.9001 13.736 11.6668C14.5601 10.4334 15 8.98336 15 7.5C14.9979 5.51154 14.207 3.60513 12.8009 2.19907C11.3949 0.793018 9.48847 0.00215068 7.5 0ZM13.0881 6.875H10.9144C10.7726 5.24681 10.2849 3.66765 9.48375 2.24313C10.4522 2.60937 11.301 3.23544 11.9368 4.05257C12.5727 4.86969 12.971 5.84626 13.0881 6.875ZM6.05313 8.75H8.94688C8.70078 10.0592 8.20991 11.3103 7.5 12.4375C6.78999 11.3103 6.29911 10.0593 6.05313 8.75ZM5.97063 6.875C6.14567 5.33986 6.66874 3.86492 7.5 2.5625C8.33137 3.86487 8.85445 5.33984 9.02938 6.875H5.97063ZM5.51625 2.24313C4.71511 3.66765 4.22736 5.24681 4.08563 6.875H1.91188C2.02897 5.84626 2.42732 4.86969 3.06319 4.05257C3.69905 3.23544 4.54781 2.60937 5.51625 2.24313ZM2.02 8.75H4.15063C4.36093 10.1569 4.82356 11.5143 5.51625 12.7569C4.64884 12.4281 3.87593 11.8905 3.26606 11.1915C2.65618 10.4926 2.22818 9.65395 2.02 8.75ZM9.48375 12.7569C10.1767 11.5145 10.6394 10.157 10.8494 8.75H12.98C12.7718 9.65395 12.3438 10.4926 11.7339 11.1915C11.1241 11.8905 10.3512 12.4281 9.48375 12.7569Z"
  //           fill="white"
  //           className="group-hover:fill-orange-200"
  //         />
  //       </g>
  //       <defs>
  //         <clipPath id="clip0_97_268">
  //           <rect width="15" height="15" fill="white" />
  //         </clipPath>
  //       </defs>
  //     </svg>
  //   ),
  // },

  // {
  //   to: "/my-agency",
  //   label: "My Agency",
  //   icon: () => (
  //     <svg
  //       width="15"
  //       height="15"
  //       viewBox="0 0 15 15"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <g clipPath="url(#clip0_227_4138)">
  //         <path
  //           d="M10.3126 15C10.082 14.9997 9.8596 14.9145 9.68792 14.7605C9.51624 14.6066 9.40731 14.3948 9.38194 14.1656C9.32627 13.706 9.10421 13.2827 8.75772 12.9757C8.41122 12.6686 7.96429 12.4991 7.50132 12.4991C7.03836 12.4991 6.59142 12.6686 6.24492 12.9757C5.89843 13.2827 5.67637 13.706 5.6207 14.1656C5.59334 14.4128 5.46894 14.6389 5.27484 14.7944C5.08074 14.9498 4.83284 15.0217 4.5857 14.9944C4.33855 14.967 4.11239 14.8426 3.95696 14.6485C3.80154 14.4544 3.72959 14.2065 3.75695 13.9594C3.86326 13.0409 4.30349 12.1935 4.99388 11.5784C5.68427 10.9633 6.57667 10.6234 7.50132 10.6234C8.42597 10.6234 9.31837 10.9633 10.0088 11.5784C10.6992 12.1935 11.1394 13.0409 11.2457 13.9594C11.2592 14.0818 11.2486 14.2056 11.2142 14.3238C11.1799 14.4421 11.1227 14.5524 11.0457 14.6485C10.9687 14.7446 10.8736 14.8247 10.7657 14.884C10.6578 14.9433 10.5393 14.9808 10.4169 14.9944C10.3823 14.9981 10.3474 15 10.3126 15ZM14.1669 9.36938C14.2893 9.35584 14.4078 9.31833 14.5157 9.25899C14.6236 9.19965 14.7187 9.11964 14.7957 9.02353C14.8727 8.92742 14.9299 8.81709 14.9642 8.69885C14.9986 8.5806 15.0092 8.45675 14.9957 8.33438C14.9242 7.4571 14.5368 6.63557 13.9054 6.02233C13.274 5.4091 12.4416 5.04583 11.5626 5C11.3139 5 11.0755 5.09877 10.8997 5.27459C10.7238 5.4504 10.6251 5.68886 10.6251 5.9375C10.6251 6.18614 10.7238 6.4246 10.8997 6.60041C11.0755 6.77623 11.3139 6.875 11.5626 6.875C11.9786 6.92256 12.3644 7.11593 12.6515 7.42084C12.9385 7.72574 13.1083 8.12246 13.1307 8.54063C13.1561 8.77002 13.2652 8.98199 13.4371 9.13594C13.6091 9.2899 13.8318 9.37502 14.0626 9.375C14.097 9.37495 14.1314 9.37308 14.1657 9.36938H14.1669ZM1.86945 8.54063C1.89185 8.12246 2.06163 7.72574 2.34869 7.42084C2.63574 7.11593 3.02151 6.92256 3.43757 6.875C3.68621 6.875 3.92467 6.77623 4.10048 6.60041C4.2763 6.4246 4.37507 6.18614 4.37507 5.9375C4.37507 5.68886 4.2763 5.4504 4.10048 5.27459C3.92467 5.09877 3.68621 5 3.43757 5C2.5588 5.04613 1.72662 5.40952 1.09548 6.02273C0.464343 6.63593 0.0771234 7.4573 0.00569543 8.33438C-0.00785572 8.45675 0.00283188 8.5806 0.0371479 8.69885C0.071464 8.81709 0.128736 8.92742 0.205694 9.02353C0.282652 9.11964 0.377789 9.19965 0.485671 9.25899C0.593552 9.31833 0.712067 9.35584 0.834445 9.36938C0.868697 9.37308 0.90312 9.37495 0.93757 9.375C1.16837 9.37502 1.39106 9.2899 1.563 9.13594C1.73495 8.98199 1.84406 8.77002 1.86945 8.54063ZM7.54819 10C7.98084 10 8.40377 9.87171 8.7635 9.63134C9.12324 9.39098 9.40361 9.04933 9.56918 8.64962C9.73475 8.24991 9.77807 7.81007 9.69366 7.38574C9.60926 6.96141 9.40092 6.57163 9.09499 6.26571C8.78906 5.95978 8.39929 5.75144 7.97496 5.66703C7.55062 5.58263 7.11079 5.62595 6.71108 5.79151C6.31136 5.95708 5.96972 6.23746 5.72936 6.59719C5.48899 6.95692 5.36069 7.37985 5.36069 7.8125C5.36069 8.39266 5.59116 8.94906 6.0014 9.3593C6.41163 9.76953 6.96803 10 7.54819 10ZM11.2982 4.375C11.7308 4.375 12.1538 4.24671 12.5135 4.00634C12.8732 3.76598 13.1536 3.42433 13.3192 3.02462C13.4847 2.62491 13.5281 2.18507 13.4437 1.76074C13.3593 1.33641 13.1509 0.946632 12.845 0.640705C12.5391 0.334778 12.1493 0.126438 11.725 0.0420332C11.3006 -0.042372 10.8608 0.000947826 10.4611 0.166515C10.0614 0.332081 9.71972 0.612459 9.47936 0.972191C9.23899 1.33192 9.11069 1.75485 9.11069 2.1875C9.11069 2.47477 9.16728 2.75922 9.27721 3.02462C9.38714 3.29002 9.54827 3.53117 9.7514 3.7343C9.95453 3.93743 10.1957 4.09856 10.4611 4.20849C10.7265 4.31842 11.0109 4.375 11.2982 4.375ZM3.7982 4.375C4.23084 4.375 4.65377 4.24671 5.0135 4.00634C5.37324 3.76598 5.65361 3.42433 5.81918 3.02462C5.98475 2.62491 6.02807 2.18507 5.94366 1.76074C5.85926 1.33641 5.65092 0.946632 5.34499 0.640705C5.03906 0.334778 4.64929 0.126438 4.22496 0.0420332C3.80062 -0.042372 3.36079 0.000947826 2.96108 0.166515C2.56136 0.332081 2.21972 0.612459 1.97936 0.972191C1.73899 1.33192 1.6107 1.75485 1.6107 2.1875C1.6107 2.76766 1.84116 3.32406 2.2514 3.7343C2.45453 3.93743 2.69568 4.09856 2.96108 4.20849C3.22648 4.31842 3.51093 4.375 3.7982 4.375Z"
  //           fill="white"
  //           className="group-hover:fill-orange-200"
  //         />
  //       </g>
  //       <defs>
  //         <clipPath id="clip0_227_4138">
  //           <rect width="15" height="15" fill="white" />
  //         </clipPath>
  //       </defs>
  //     </svg>
  //   ),
  // },

  {
    to: "/tutorials",
    label: "Tutorials",
    icon: () => (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_97_165)">
          <path
            d="M7.5 0C6.01664 0 4.5666 0.439867 3.33323 1.26398C2.09986 2.08809 1.13856 3.25943 0.570907 4.62987C0.00324965 6.00032 -0.145275 7.50832 0.144114 8.96318C0.433503 10.418 1.14781 11.7544 2.1967 12.8033C3.2456 13.8522 4.58197 14.5665 6.03683 14.8559C7.49168 15.1453 8.99968 14.9968 10.3701 14.4291C11.7406 13.8614 12.9119 12.9001 13.736 11.6668C14.5601 10.4334 15 8.98336 15 7.5C14.9979 5.51154 14.207 3.60513 12.8009 2.19907C11.3949 0.793018 9.48847 0.00215068 7.5 0ZM7.5 13.125C6.38748 13.125 5.29995 12.7951 4.37492 12.177C3.44989 11.5589 2.72892 10.6804 2.30318 9.6526C1.87744 8.62476 1.76604 7.49376 1.98309 6.40262C2.20013 5.31147 2.73586 4.3092 3.52253 3.52252C4.3092 2.73585 5.31148 2.20012 6.40262 1.98308C7.49376 1.76604 8.62476 1.87743 9.6526 2.30318C10.6804 2.72892 11.5589 3.44989 12.177 4.37492C12.7951 5.29994 13.125 6.38748 13.125 7.5C13.1233 8.99134 12.5302 10.4211 11.4757 11.4756C10.4211 12.5302 8.99134 13.1233 7.5 13.125Z"
            fill="white"
            className="group-hover:fill-orange-200"
          />
          <path
            d="M7.50311 11.875C8.02088 11.875 8.44061 11.4553 8.44061 10.9375C8.44061 10.4197 8.02088 10 7.50311 10C6.98535 10 6.56561 10.4197 6.56561 10.9375C6.56561 11.4553 6.98535 11.875 7.50311 11.875Z"
            fill="white"
            className="group-hover:fill-orange-200"
          />
          <path
            d="M7.97314 3.11688C7.59084 3.04834 7.19816 3.06447 6.82277 3.16414C6.44738 3.26381 6.09841 3.44458 5.80046 3.69373C5.50251 3.94288 5.26281 4.25434 5.09828 4.60616C4.93374 4.95799 4.84835 5.34161 4.84814 5.73001C4.84814 5.97865 4.94692 6.21711 5.12273 6.39292C5.29855 6.56874 5.537 6.66751 5.78564 6.66751C6.03429 6.66751 6.27274 6.56874 6.44856 6.39292C6.62437 6.21711 6.72314 5.97865 6.72314 5.73001C6.72371 5.59247 6.76064 5.45752 6.83018 5.33886C6.89972 5.22019 6.99941 5.12202 7.11912 5.05431C7.23884 4.98659 7.37434 4.95174 7.51187 4.95328C7.6494 4.95482 7.78408 4.9927 7.90226 5.06308C8.02043 5.13345 8.11789 5.23383 8.18476 5.35402C8.25162 5.47421 8.28552 5.60995 8.28301 5.74747C8.2805 5.88499 8.24167 6.0194 8.17045 6.13707C8.09924 6.25474 7.99818 6.35149 7.87752 6.41751C7.49079 6.57948 7.16214 6.85471 6.93479 7.207C6.70744 7.55929 6.59204 7.97214 6.60377 8.39126C6.60377 8.6399 6.70254 8.87836 6.87836 9.05417C7.05417 9.22999 7.29263 9.32876 7.54127 9.32876C7.78991 9.32876 8.02837 9.22999 8.20418 9.05417C8.38 8.87836 8.47877 8.6399 8.47877 8.39126C8.47819 8.34564 8.48154 8.30006 8.48877 8.25501C8.5763 8.17512 8.67558 8.10914 8.78315 8.05938C9.26326 7.79475 9.64968 7.38798 9.88935 6.89492C10.129 6.40187 10.2102 5.84672 10.1217 5.30569C10.0332 4.76466 9.77943 4.26428 9.39518 3.87327C9.01092 3.48226 8.51505 3.21978 7.97564 3.12188L7.97314 3.11688Z"
            fill="white"
            className="group-hover:fill-orange-200"
          />
        </g>
        <defs>
          <clipPath id="clip0_97_165">
            <rect width="15" height="15" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  // Resources tab temporarily hidden — Airtable embed is no longer connected.
  // Re-enable by uncommenting this block and the route entries in router/index.js and router/routes.js.
  // {
  //   to: "/resources",
  //   label: "Resources",
  //   icon: () => (
  //     <svg
  //       fill="#ffffff"
  //       height="15px"
  //       width="15px"
  //       version="1.1"
  //       id="XMLID_100_"
  //       xmlns="http://www.w3.org/2000/svg"
  //       viewBox="0 0 24 24"
  //       stroke="#ffffff"
  //       className="group-hover:fill-orange-200"
  //     >
  //       <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
  //       <g
  //         id="SVGRepo_tracerCarrier"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       ></g>
  //       <g id="SVGRepo_iconCarrier">
  //         {" "}
  //         <g id="resources">
  //           {" "}
  //           <g>
  //             {" "}
  //             <path d="M12,23L0,17l4.9-2.5L0,12l4.9-2.5L0,7l12-6l12,6l-4.9,2.5L24,12l-4.9,2.5L24,17L12,23z M4.4,17l7.7,3.9l7.6-3.9l-2.8-1.4 L12,18l-4.9-2.5L4.4,17z M4.4,12l7.7,3.9l7.6-3.9l-2.8-1.4L12,13.1l-4.9-2.5L4.4,12z M4.4,7l7.7,3.9L19.7,7L12,3.2L4.4,7z"></path>{" "}
  //           </g>{" "}
  //         </g>{" "}
  //       </g>
  //     </svg>
  //   ),
  // },

  {
    to: "/reporting",
    label: "Reporting",
    icon: () => (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_97_261)">
          <path
            d="M14.0625 13.125H3.4375C3.0231 13.125 2.62567 12.9604 2.33265 12.6674C2.03962 12.3743 1.875 11.9769 1.875 11.5625V0.9375C1.875 0.68886 1.77623 0.450403 1.60041 0.274587C1.4246 0.098772 1.18614 0 0.9375 0C0.68886 0 0.450403 0.098772 0.274587 0.274587C0.098772 0.450403 0 0.68886 0 0.9375L0 11.5625C0.000992606 12.4739 0.363476 13.3476 1.00792 13.9921C1.65236 14.6365 2.52612 14.999 3.4375 15H14.0625C14.3111 15 14.5496 14.9012 14.7254 14.7254C14.9012 14.5496 15 14.3111 15 14.0625C15 13.8139 14.9012 13.5754 14.7254 13.3996C14.5496 13.2238 14.3111 13.125 14.0625 13.125Z"
            fill="white"
            className="group-hover:fill-orange-200"
          />
          <path
            d="M5.9375 5.625C5.68886 5.625 5.4504 5.72377 5.27459 5.89959C5.09877 6.0754 5 6.31386 5 6.5625V10.9375C5 11.1861 5.09877 11.4246 5.27459 11.6004C5.4504 11.7762 5.68886 11.875 5.9375 11.875C6.18614 11.875 6.4246 11.7762 6.60041 11.6004C6.77623 11.4246 6.875 11.1861 6.875 10.9375V6.5625C6.875 6.31386 6.77623 6.0754 6.60041 5.89959C6.4246 5.72377 6.18614 5.625 5.9375 5.625Z"
            fill="white"
            className="group-hover:fill-orange-200"
          />
          <path
            d="M8.75 8.4375V10.9375C8.75 11.1861 8.84877 11.4246 9.02459 11.6004C9.2004 11.7762 9.43886 11.875 9.6875 11.875C9.93614 11.875 10.1746 11.7762 10.3504 11.6004C10.5262 11.4246 10.625 11.1861 10.625 10.9375V8.4375C10.625 8.18886 10.5262 7.9504 10.3504 7.77459C10.1746 7.59877 9.93614 7.5 9.6875 7.5C9.43886 7.5 9.2004 7.59877 9.02459 7.77459C8.84877 7.9504 8.75 8.18886 8.75 8.4375Z"
            fill="white"
            className="group-hover:fill-orange-200"
          />
          <path
            d="M12.5 5.9375V10.9375C12.5 11.1861 12.5988 11.4246 12.7746 11.6004C12.9504 11.7762 13.1889 11.875 13.4375 11.875C13.6861 11.875 13.9246 11.7762 14.1004 11.6004C14.2762 11.4246 14.375 11.1861 14.375 10.9375V5.9375C14.375 5.68886 14.2762 5.4504 14.1004 5.27459C13.9246 5.09877 13.6861 5 13.4375 5C13.1889 5 12.9504 5.09877 12.7746 5.27459C12.5988 5.4504 12.5 5.68886 12.5 5.9375Z"
            fill="white"
            className="group-hover:fill-orange-200"
          />
          <path
            d="M3.74998 4.68751C3.96277 4.68796 4.16927 4.61537 4.33498 4.48188L5.75873 3.34376C6.04623 3.11295 6.40887 2.99652 6.77698 3.01682C7.1451 3.03712 7.49274 3.19273 7.75311 3.45376C8.35398 4.047 9.15443 4.39494 9.99811 4.42961C10.8418 4.46428 11.6681 4.18319 12.3156 3.64126L14.6681 1.65063C14.7683 1.57316 14.8518 1.47618 14.9135 1.36555C14.9752 1.25491 15.0139 1.13292 15.0271 1.00694C15.0404 0.880953 15.028 0.75359 14.9906 0.632538C14.9533 0.511487 14.8918 0.399259 14.8099 0.302631C14.728 0.206003 14.6273 0.126979 14.514 0.070331C14.4007 0.0136831 14.2771 -0.0194134 14.1506 -0.0269603C14.0242 -0.0345072 13.8975 -0.0163478 13.7783 0.0264214C13.659 0.0691906 13.5497 0.135682 13.4569 0.221881L11.105 2.21251C10.8169 2.45271 10.4496 2.57685 10.0749 2.56067C9.70022 2.54448 9.34501 2.38914 9.07873 2.12501C8.49252 1.53715 7.70986 1.1865 6.88096 1.14036C6.05205 1.09422 5.23531 1.35584 4.58748 1.87501L3.16436 3.01813C3.01274 3.13951 2.90256 3.30497 2.84904 3.49167C2.79552 3.67837 2.80131 3.87708 2.8656 4.06034C2.92989 4.24361 3.04951 4.40239 3.20794 4.51473C3.36636 4.62708 3.55576 4.68745 3.74998 4.68751Z"
            fill="white"
            className="group-hover:fill-orange-200"
          />
        </g>
        <defs>
          <clipPath id="clip0_97_261">
            <rect width="15" height="15" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    to: "/ai-visibility",
    label: "AI Visibility",
    icon: () => (
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 16C9.79 16 8 14.21 8 12C8 9.79 9.79 8 12 8C14.21 8 16 9.79 16 12C16 14.21 14.21 16 12 16Z"
          fill="white"
          className="group-hover:fill-orange-200"
        />
      </svg>
    ),
  },
  {
    to: "/keyword-research",
    label: "Keyword Research",
    icon: () => (
      <svg
        width="15"
        height="15"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7" cy="7" r="5" stroke="white" strokeWidth="1.6" className="group-hover:stroke-orange-200" />
        <path d="M11 11L14 14" stroke="white" strokeWidth="1.6" strokeLinecap="round" className="group-hover:stroke-orange-200" />
      </svg>
    ),
  },
  // {
  //   to: "/integrations",
  //   label: "Integrations",
  //   icon: () => (
  //     <svg
  //       width="15"
  //       height="15"
  //       viewBox="0 0 15 15"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <g clipPath="url(#clip0_97_171)">
  //         <path
  //           d="M15 2.5C15 3.88063 13.8806 5 12.5 5C11.1194 5 10 3.88063 10 2.5C10 1.11937 11.1194 0 12.5 0C13.8806 0 15 1.11937 15 2.5ZM10 10C8.61938 10 7.5 11.1194 7.5 12.5C7.5 13.8806 8.61938 15 10 15C11.3806 15 12.5 13.8806 12.5 12.5C12.5 11.1194 11.3806 10 10 10ZM2.5 3.125C1.11937 3.125 0 4.24437 0 5.625C0 7.00563 1.11937 8.125 2.5 8.125C3.88063 8.125 5 7.00563 5 5.625C5 4.24437 3.88063 3.125 2.5 3.125ZM7.3525 8.80125L6.415 7.94187C6.03375 7.5925 5.44 7.61687 5.09063 7.99937C4.74063 8.38062 4.76625 8.97437 5.14813 9.32375L6.08563 10.1831C6.26563 10.3487 6.4925 10.43 6.71938 10.43C6.9725 10.43 7.22563 10.3275 7.41 10.1262C7.76 9.745 7.73438 9.15125 7.3525 8.80188V8.80125ZM11.0944 9.0625C11.5144 9.0625 11.8969 8.77812 12.0031 8.3525L12.3156 7.1025C12.4412 6.6 12.1363 6.09125 11.6337 5.96562C11.1263 5.83938 10.6219 6.14562 10.4969 6.6475L10.1844 7.8975C10.0588 8.39937 10.3637 8.90875 10.8663 9.03438C10.9431 9.05313 11.0194 9.0625 11.0944 9.0625ZM6.8125 5.215C6.90437 5.215 6.99937 5.20125 7.09188 5.17188L8.46625 4.74187C8.96062 4.5875 9.23563 4.06188 9.08125 3.5675C8.9275 3.07438 8.40187 2.79938 7.90688 2.9525L6.5325 3.3825C6.03812 3.53688 5.76313 4.0625 5.9175 4.55687C6.0425 4.95813 6.41312 5.215 6.8125 5.215Z"
  //           fill="white"
  //           className="group-hover:fill-orange-200"
  //         />
  //       </g>
  //       <defs>
  //         <clipPath id="clip0_97_171">
  //           <rect width="15" height="15" fill="white" />
  //         </clipPath>
  //       </defs>
  //     </svg>
  //   ),
  // },
];
export default sidebarMenuConfig;
